import { render, staticRenderFns } from "./LegacyCoverage.vue?vue&type=template&id=a2108338&"
import script from "./LegacyCoverage.vue?vue&type=script&lang=js&"
export * from "./LegacyCoverage.vue?vue&type=script&lang=js&"
import style0 from "./LegacyCoverage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports